const BackgroundImage = ({ mode }: { mode: string }) => {
  return (
    <div className="absolute inset-0 z-10 opacity-5">
      <img
        src={`/images/${mode}-bg-v3.png`}
        alt="Background art"
        className="h-full w-full object-cover object-right"
      />
    </div>
  );
};

export default BackgroundImage;
